<template>
  <a-modal v-model="leaveApplyForVisible"
           title="请假"
           :dialog-style="{ top: '20px' }"
           :confirmLoading="confirmLoading"
           okText="确认请假"
           @ok="submitLeLeaveApplyFor"
           @cancel="handleCancel">
    <a-form-model ref="form"
                  :model="leaveApplyForData"
                  :rules="rules"
                  :label-col="{ flex: '0 0 auto' }"
                  :wrapper-col="{ span: 24 }"
                  class="exi_form item_100">
      <a-form-model-item label="请假原因"
                         prop="leaveReason">
        <a-textarea v-model="leaveApplyForData.leaveReason"
                    rows="4"
                    placeholder="请输入请假原因"></a-textarea>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { ExpertLeaveBySelf } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment'

export default {
  name: 'ExpertLeaveApplyForModal',
  data () {
    return {
      confirmLoading: false,
      leaveApplyForVisible: false,
      leaveApplyForData: { id: '', applyId: '', leaveReason: '' },
      rules: {
        leaveReason: [{ required: true, message: '请输入请假原因', trigger: 'blur' },
        { max: 500, message: '请假原因不能超过500个字', trigger: 'change' }]
      }
    }
  },
  methods: {
    init (record) {
      const minutes = moment(record.setOfTime).diff(moment(), 'minutes')
      if (minutes/60 <= 2) {
        this.$warning({
          title: '温馨提示',
          content: `离集合时间不足两个小时，请拨打联系电话（${record.reviewTelephone}）进行请假，以便我们及时获悉并更换专家，谢谢配合。`,
        })
        return
      }
      this.leaveApplyForData.id = record.id
      this.leaveApplyForData.applyId = record.applyId
      this.leaveApplyForVisible = true
    },
    handleCancel () {
      this.leaveApplyForVisible = false
    },
    submitLeLeaveApplyFor () {
      this.$refs.form.validate(async (valid, err) => {
        if (!valid) {
          return
        }
        this.handleLeaveApplyFor()
      })
    },
    async handleLeaveApplyFor () {
      this.confirmLoading = true
      const res = await ExpertLeaveBySelf(this.leaveApplyForData)
      if (res.code == 200) {
        this.leaveApplyForVisible = false
        this.$message.success('请假成功')
        this.$emit('leaveSuccess')
      } else {
        this.$message.error(res.message)
      }
      this.confirmLoading = false
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
